/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Alarms_Import_Error_Nogateway1Inputs */



/**
* | output |
* | --- |
* | "Please select a Box." |
*
* @param {Alarms_Import_Error_Nogateway1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const alarms_import_error_nogateway1 = /** @type {((inputs?: Alarms_Import_Error_Nogateway1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Alarms_Import_Error_Nogateway1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Please select a Box.")
	return /** @type {LocalizedString} */ ("Veuillez sélectionner une Box.")
});
export { alarms_import_error_nogateway1 as "alarms_import_error_noGateway" }